<interacta-user-menu-title
    [label]="'SHARED.USER_MENU.SELECT_LANGUAGE' | translate"
    (back)="back.emit()"
/>

<interacta-user-menu-separator />

<div
    class="flex flex-col items-center"
    interactaArrowKeysList
    role="menu"
    [selectedIndex]="currentIndex()"
    (changeSelectedIndex)="currentIndex.set($event)"
>
    @for (language of availableLanguages(); track language.code) {
        @let selectedLanguage = language.code === currentLanguage().code;
        <button
            class="w-full"
            interacta-user-menu-button
            interactaArrowKeysItem
            type="button"
            [attr.aria-pressed]="selectedLanguage"
            [attr.cdkFocusInitial]="$first ? '' : null"
            [class.text-text-primary]="selectedLanguage"
            [width]="'full'"
            (click)="changeLanguage.emit(language)"
        >
            {{ language.description }}
        </button>
    }
</div>
